// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"7636448f26774a2722b0","655":"46b6fa7d914cff9049e8"}[chunkId] + ".js";
};